/* eslint-disable @typescript-eslint/naming-convention */
export interface PhysicalAddress {
  Street1: string;
  Street2: string;
  City: string;
  State: string;
  PostCode: string;
  Country: string;
}
